export default __webpack_public_path__ + "static/media/Frame.13eb6de2.png";